import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_test_noise_exposure_levels_line_legal'

export const dataPointDefinition = {
  retracedId: 'does_facility_test_noise_exposure_levels_line_legal',
  name: 'Does the facility test noise exposure levels in line with legal requirements? ',
  description:
    '"Noise testing" refers to measuring sound exposure levels in the facility. Specifically in areas where noise exposure levels are the highest (e.g. next to loud machinery). Testing might include baseline testing and periodic testing (i.e. every six months, annually, etc.)',
  meta: {
    slcpMeta: {
      key: 'hs-3--2',
      number: 'HS-GEN-11',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-3--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29270,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
